import TextOffCanvas from '../OffCanvas/TextOffCanvas/TextOffCanvas';

function Text({
  show,
  text,
  title,
  color,
  preview,
  initialValue,
  fontSize,
  alignment,
  //
  handleSave,
  handleShow,
  handleClose
}) {
  return (
    <>
      <div
        className={`${preview ? '' : 'c-container'}`}
        onClick={() => !preview && handleShow()}
        style={{
          fontSize: `${fontSize}px`,
          color: color,
          textAlign: alignment
        }}>
        {text || 'Click here to add ' + title}
      </div>

      <TextOffCanvas
        show={show}
        title={title}
        initialValue={initialValue}
        handleClose={handleClose}
        handleSave={handleSave}
      />
    </>
  );
}

export default Text;
